<template>
  <div class="topnav">
    <div class="container-fluid">
      <nav class="navbar navbar-light navbar-expand-lg topnav-menu active">
        <div class="collapse navbar-collapse active" id="topnav-menu-content">
          <ul class="navbar-nav">
            <!-- Menu data -->

            <li
              class="nav-item dropdown cursor-pointer"
              v-for="(item, index) in menuItems"
              :key="index + 'm'"
            >
              <div
                class="nav-link dropdown-toggle arrow-none cursor-pointer"
                tag="a"
                href="javascript: void(0);"
                @click="hasItems(item) ? null : onMenuClick(item.route_name)"
              >
                <i :class="`bx ${item.icon} mr-2`"></i>
                {{ $t(displayName(item)) }}
                <div v-if="hasItems(item)" class="arrow-down"></div>
              </div>

              <div
                class="dropdown-menu row"
                aria-labelledby="topnav-dashboard"
                v-if="hasItems(item)"
              >
                <span
                  v-for="(subitem, index2) of item.items"
                  :key="index2 + 's'"
                >
                  <div
                    class="dropdown cursor-pointer"
                    v-if="hasItems(subitem)"
                    @click="
                      hasItems(subitem) ? null : onMenuClick(item.route_name)
                    "
                  >
                    <div
                      class="col dropdown-item side-nav-link-ref cursor-pointer"
                      v-if="!hasItems(subitem)"
                      @click="
                        hasItems(subitem) ? null : onMenuClick(item.route_name)
                      "
                    >
                      {{ $t(displayName(subitem)) }}
                    </div>
                    <a
                      class="dropdown-item cursor-pointer"
                      href="javascript: void(0);"
                    >
                      {{ $t(displayName(subitem)) }}
                      <div class="arrow-down"></div>
                    </a>
                    <div class="dropdown-menu row">
                      <template v-for="(subSubitem, index) of subitem.items">
                        <div
                          class="col dropdown-item side-nav-link-ref cursor-pointer"
                          @click="onMenuClick(subSubitem.route_name)"
                          :key="index + 'ss'"
                        >
                          {{ $t(displayName(subSubitem)) }}
                        </div>
                      </template>
                    </div>
                  </div>
                  <div
                    v-else
                    class="col dropdown-item side-nav-link-ref"
                    @click="onMenuClick(subitem.route_name)"
                  >
                    {{ $t(displayName(subitem)) }}
                  </div>
                </span>
              </div>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
import { layoutMethods } from "@/state/helpers";
import axios from "axios";
import { menuItems } from "./horizontal-menu";
import authorizeProvider from "@/helpers/service/authorize-provider";
const HttpClient = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 60000,
});
export default {
  data() {
    return {
      menuItems: [],
    };
  },
  updated() {
    this.matchingMenu();
  },
  async created() {
    this.onGetMenuItems();
  },
  mounted() {
    // var links = document.getElementsByClassName("side-nav-link-ref");
    // var matchingMenuItem = null;
    // for (var i = 0; i < links.length; i++) {
    //   if (window.location.pathname === links[i].pathname) {
    //     matchingMenuItem = links[i];
    //     break;
    //   }
    // }
    // if (matchingMenuItem) {
    //   matchingMenuItem.classList.add("active");
    //   var parent = matchingMenuItem.parentElement;
    //   /**
    //    * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
    //    * We should come up with non hard coded approach
    //    */
    //   if (parent) {
    //     parent.classList.add("active");
    //     const parent2 = parent.parentElement;
    //     if (parent2) {
    //       parent2.classList.add("active");
    //     }
    //     const parent3 = parent2.parentElement;
    //     if (parent3) {
    //       parent3.classList.add("active");
    //       var childAnchor = parent3.querySelector(".has-dropdown");
    //       if (childAnchor) childAnchor.classList.add("active");
    //     }
    //     const parent4 = parent3.parentElement;
    //     if (parent4) parent4.classList.add("active");
    //     const parent5 = parent4.parentElement;
    //     if (parent5) parent5.classList.add("active");
    //   }
    // }
  },
  methods: {
    ...layoutMethods,
    displayName(item) {
      if(this.$validate.isObjectValid(item.display_name)) {
        if (this.$validate.isTrimValid(item.display_name.en)) {
          return item.display_name.en
        } else if (this.$validate.isTrimValid(item.display_name.th)) {
          return item.display_name.th
        }
      }
      return item.view_name
    },
    hasItems(item) {
      // console.log(item);
      return item.items !== undefined ? item.items.length > 0 : false;
    },
    onMenuClick(name) {
      // Check if name is a URL
      try {
        new URL(name);
        // If it's a valid URL, use window.location
        window.location.href = name;
        return;
      } catch (e) {
        // Not a valid URL, treat as route name
      }
      
      // Default behavior: use router push for route names
      return this.$router.push({
        name,
      });
    },
    matchingMenu() {
      var links = document.getElementsByClassName("side-nav-link-ref");
      var matchingMenuItem = null;
      const paths = [];

      for (var i = 0; i < links.length; i++) {
        paths.push(links[i]["pathname"]);
      }
      var itemIndex = paths.indexOf(window.location.pathname);
      if (itemIndex === -1) {
        const strIndex = window.location.pathname.lastIndexOf("/");
        const item = window.location.pathname.substr(0, strIndex).toString();
        matchingMenuItem = links[paths.indexOf(item)];
      } else {
        matchingMenuItem = links[itemIndex];
      }

      if (matchingMenuItem) {
        matchingMenuItem.classList.add("active");
        var parent = matchingMenuItem.parentElement;

        /**
         * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
         * We should come up with non hard coded approach
         */
        if (parent) {
          parent.classList.add("mm-active");
          const parent2 = parent.parentElement.closest("ul");
          if (parent2 && parent2.id !== "side-menu") {
            parent2.classList.add("mm-show");

            const parent3 = parent2.parentElement;
            if (parent3) {
              parent3.classList.add("mm-active");
              var childAnchor = parent3.querySelector(".has-arrow");
              var childDropdown = parent3.querySelector(".has-dropdown");
              if (childAnchor) childAnchor.classList.add("mm-active");
              if (childDropdown) childDropdown.classList.add("mm-active");

              const parent4 = parent3.parentElement;
              if (parent4 && parent4.id !== "side-menu") {
                parent4.classList.add("mm-show");
                const parent5 = parent4.parentElement;
                if (parent5 && parent5.id !== "side-menu") {
                  parent5.classList.add("mm-active");
                  const childanchor = parent5.querySelector(".is-parent");
                  if (childanchor && parent5.id !== "side-menu") {
                    childanchor.classList.add("mm-active");
                  }
                }
              }
            }
          }
        }
      }
    },
    async onGetMenuItems() {
      var accessToken = this.$cookies.get(".at");
      if (accessToken === null) window.location = "/login";

      const responsed = await authorizeProvider.getMenuItems(accessToken);

      if (responsed.status == 200) {
        this.menuItems = responsed.data.menuItems.sort((a, b) => {
          return a.sequence < b.sequence;
        });
        // console.log(
        //   "responsed.data.menuItems",
        //   this.menuItems,
        //   responsed.data.menuItems.sort((a, b) => {
        //     return a.sequence < b.sequence;
        //   })
        // );
      } else if (responsed.status == 404) console.log("ไม่มีสิทธิ์");
    },
    onToggleSubMenu(index, submenu) {
      if (
        this.$refs[`submenu${submenu}_${index}`][0].classList.contains(
          "mm-show"
        )
      ) {
        this.$refs[`submenu${submenu}_${index}`][0].classList.remove("mm-show");
        this.$refs[`li${submenu}_${index}`][0].classList.remove("mm-active");
      } else {
        this.$refs[`submenu${submenu}_${index}`][0].classList.add("mm-show");
        this.$refs[`li${submenu}_${index}`][0].classList.add("mm-active");
      }
    },
  },
};
</script>
<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
